import styled from 'styled-components';
import * as glx from 'assets/css/glx';

export const BgImg = glx.BgImg;

export const Header = styled.div`
  position: relative;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 1400px;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
`;


export const Ul = styled.ul`
  /* margin-left: 168px; */
  display: flex;
  margin-left:auto;
`;

export const Li = styled.li`
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-right: 30px;
  }
`;

export const LiIcon = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: block;
`;

export const LiContent = styled.div`
  margin-left: 15px;
`;

export const LiTitle = styled.div`
  line-height: 1;
  font-size: 19px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(0, 255, 228, 1);
`;

export const LiSubTitle = styled.div`
  line-height: 1;
  margin-top: 9px;

  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 255, 228, 0.7);
`;
